import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import getToken from '../auth/getToken';
import AuthStatusScreen from '../components/Auth/AuthStatusScreen';
import { isLoadTestAuthEnabled } from '../auth/loadTestAuth';

// Aktualisierte ProtectedRoute für React Router v6
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const [tokenValid, setTokenValid] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;

    const validateToken = async () => {
      if (isLoadTestAuthEnabled()) {
        setTokenValid(true);
        return;
      }
      if (!isAuthenticated || inProgress !== InteractionStatus.None) {
        setTokenValid(null);
        return;
      }

      setTokenValid(null);
      try {
        const token = await getToken(instance, [
          `${process.env.REACT_APP_CLIENT_ID}/.default`,
        ]);
        if (!cancelled) setTokenValid(Boolean(token));
      } catch (error) {
        if (!cancelled) setTokenValid(false);
      }
    };

    validateToken();

    return () => {
      cancelled = true;
    };
  }, [instance, inProgress, isAuthenticated]);

  if (isLoadTestAuthEnabled()) {
    return children;
  }

  if (inProgress !== InteractionStatus.None) {
    // Noch in Prüfung – nicht redirecten!
    return null;
  }

  if (!isAuthenticated || tokenValid === false) {
    return <Navigate to="/login" replace />;
  }

  if (tokenValid === null) {
    return (
      <AuthStatusScreen
        title="Sitzung wird geprüft"
        subtitle="Die Anmeldung wird validiert."
      />
    );
  }

  return children;
};

export default ProtectedRoute;
